import { render, staticRenderFns } from "./DisbursedLoanReport.vue?vue&type=template&id=97d458bc&scoped=true&"
import script from "./DisbursedLoanReport.vue?vue&type=script&lang=js&"
export * from "./DisbursedLoanReport.vue?vue&type=script&lang=js&"
import style0 from "./DisbursedLoanReport.vue?vue&type=style&index=0&id=97d458bc&lang=scss&scoped=true&"
import style1 from "./DisbursedLoanReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d458bc",
  null
  
)

export default component.exports